import { DataService } from "@/services/data";
import { Navigate, redirect, RouteObject } from "react-router-dom";

const TIMELINE_PAGE_SIZE = 200;

const CardRoute: RouteObject = {
    path: "fiches",
    children: [
        {
            // The card list is served by `sf_like` from `CardConfig` now. Kept as a
            // redirect for the breadcrumbs and deep links that still name this URL.
            index: true,
            element: <Navigate to="/dialer-cards" replace />
        },
        {
            // The journal lives on the SFLike detail now (`CardJournalTab`). Deep links
            // and related-list bookmarks that still name the bespoke URL land on that
            // tab rather than on the fields-only Informations tab.
            path: ":card_id",
            loader: async ({ params }) => {
                return redirect(`/dialer-cards/${params.card_id}/journal`);
            }
        },
        {
            // Resource route feeding both "Load newer events" and "Load older events"
            // from the Journal tab. `before_sequence` wins when present, as it does
            // server-side, so the two buttons cannot be conflated into one ambiguous
            // request. Kept under this path so existing fetchers keep working after the
            // page itself became a redirect.
            path: ":card_id/chronologie",
            loader: async ({ params, request }) => {
                const search = new URL(request.url).searchParams;
                const before = search.get("before_sequence");
                const cursor = before ? `before_sequence=${Number(before)}` : `after_sequence=${Number(search.get("after_sequence") ?? 0)}`;
                return DataService.client.url(`/dialer/cards/${params.card_id}/timeline/?${cursor}&limit=${TIMELINE_PAGE_SIZE}`).get().json();
            }
        }
    ]
};

export default CardRoute;
